<template>
  <div>
    <!-- A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
    <div
      class="responsive-print"
      :id="field.temp_prop.paper_size==0?field.temp_prop.orientation==0?'a4-standard-portrait-page':'a4-standard-landscape-page':field.temp_prop.orientation==0?'a5-standard-portrait-page':'a5-standard-landscape-page'"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.13);"
    >
      <div
        class="print-template"
        :style="{'font-size':(field.temp_prop.font_size||8)+'pt','color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000','background':field.temp_prop.hasOwnProperty('bg_color')&&field.temp_prop.bg_color.show?field.temp_prop.bg_color.value.hex:'#fff'}"
      >
        <!-- Header margin top value as height -->
        <div
          class="invoice-header-block"
          :style="{'height':field.temp_prop.margin_top+'in','background':field.header_prop.is_header_bg_color==1?field.header_prop.header_bg_color.hex:'#fff'}"
        ></div>
        <!-- Body -->
        <div
          class="invoice-content-layout"
          :style="{'padding-right':field.temp_prop.margin_right+'in','padding-left':field.temp_prop.margin_left+'in'}"
        >
          <!-- Page Heading -->
          <h5
            v-if="field.header_prop.show_doc_title"
            :style="{'font-size':field.header_prop.doc_title_size+'pt','color':field.header_prop.doc_title_color.hex}"
            class="text-center invoice-top-heading"
          >{{field.header_prop.doc_title}}</h5>
          <!-- First Block -->
          <div class="invoice-first-block" style="display:flex;justify-content: space-between;">
            <!-- Organization Details -->
            <div>
              <div
                v-if="field.header_prop.show_org_name"
                :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
                style="margin-bottom:1px;font-weight:500;"
              >Shanki Systems India Pvt Ltd</div>

              <div
                v-if="field.header_prop.show_org_addr"
                class="custom-invoice-address"
                :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
              >
                <p>JKR Tower</p>
                <p>5/4 Moonlight Garden</p>
                <p>Coimbatore Tamil Nadu</p>
                <p>India 641048</p>
                <p>Mail: admin@shanki.com</p>
                <p>{{field.header_prop.phone}}: 76639488488</p>
                <!-- <p v-if="field.header_prop.hasOwnProperty('fax')">{{field.header_prop.fax}}: 123123</p> -->
                <p style="margin-bottom:0px;">GSTIN: 12ASDF12345A1Z0</p>
              </div>
            </div>
            <div v-if="field.header_prop.show_status_stamp&&field.menu_id!=3">
              <span
                class="stamp is-approved"
              >{{ field.menu_id ==5 ? 'DELIVERED' :field.menu_id ==10 ? 'SHIPPED' :'PAID' }}</span>
            </div>
            <!-- Organization Logo -->
            <div>
              <!-- Max width for Logo Block -->

              <!-- Logo Image -->
              <img
                v-if="field.header_prop.show_logo&&imageSrc!=''"
                :src="imageSrc"
                :style="{'width':field.header_prop.logo_width+'px'}"
                style="max-width:300px;max-height:183.05px;height:auto;"
              />
              <img
                v-if="field.header_prop.show_logo&&imageSrc==''"
                src="@/assets/logo/Shanki-logo.png"
                :style="{'width':field.header_prop.logo_width+'px'}"
                style="max-width:300px;max-height:183.05px;height:auto;"
              />
            </div>
          </div>
          <!-- End of First Block -->
          <div style="border-top:1px solid #ededed;margin-bottom:5px;"></div>
          <!-- Second Block -->
          <div class="invoice-second-block" style="display:flow-root">
            <div style="display:flex;justify-content: space-between;">
              <!-- Bill Address -->
              <div v-if="field.header_prop.doc_bill_to.show">
                <div
                  style="margin-bottom:1px;font-weight:500;word-break: break-word !important;width:180px !important"
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                >{{field.header_prop.doc_bill_to.label}}</div>
                <div
                  :style="{'font-size':field.header_prop.cus_name_size+'pt','color':field.header_prop.cus_name_color.hex}"
                  style="margin-bottom:1px;font-weight:500;word-break: break-word !important"
                >Shanki Systems India Pvt Ltd</div>

                <div class="custom-invoice-address" style="word-break: break-word !important">
                  <p>JKR Tower</p>
                  <p>5/4 Moonlight Garden</p>
                  <p>Coimbatore Tamil Nadu</p>
                  <p>India 641048</p>
                  <p>Ph: 76639488488</p>
                  <p>GSTIN: 12ASDF12345A1Z0</p>
                </div>
              </div>
              <!-- Shipping Address -->
              <div v-if="field.header_prop.doc_ship_to.show && field.menu_id!=3">
                <div
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  style="margin-bottom:1px;font-weight:500;word-break: break-word !important;width:180px !important"
                >{{field.header_prop.doc_ship_to.label}}</div>
                <div
                  :style="{'font-size':field.header_prop.cus_name_size+'pt','color':field.header_prop.cus_name_color.hex}"
                  style="margin-bottom:1px;font-weight:500;word-break: break-word !important"
                >Shanki Systems India Pvt Ltd</div>

                <div class="custom-invoice-address" style="word-break: break-word !important">
                  <p>JKR Tower</p>
                  <p>5/4 Moonlight Garden</p>
                  <p>Coimbatore Tamil Nadu</p>
                  <p>India 641048</p>
                  <p>Ph: 76639488488</p>
                  <p>GSTIN: 12ASDF12345A1Z0</p>
                </div>
              </div>

              <!-- Invoice Details-->
              <div>
                <!-- v-if="field.header_prop.show_inv_no" -->
                <div
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  style="margin-bottom:1px;font-weight:500;text-align:right"
                >
                  <span
                    v-if="field.header_prop.hasOwnProperty('doc_no')&&field.header_prop.doc_no.show"
                    style="word-break: break-word !important"
                  >{{field.header_prop.doc_no.label}} :</span>
                  {{field.menu_id==1?$AppDetails.financial_year+'/INV14468':field.menu_id==2?$AppDetails.financial_year+'/QOT10005':field.menu_id==3?$AppDetails.financial_year+'/CN10005':field.menu_id==4?$AppDetails.financial_year+'/ORD10013':field.menu_id==5?'PKG10001':field.menu_id==7?$AppDetails.financial_year+'/PO10009':field.menu_id==8?$AppDetails.financial_year+'/BILL5':field.menu_id==9?$AppDetails.financial_year+'/VN10005':field.menu_id==10?'SHP10001':''}}
                </div>

                <table class="custom-invoice-details-table">
                  <tbody>
                    <tr v-if="field.header_prop.doc_date.show">
                      <td
                        style="word-break: break-word !important"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_date.label}} :</td>
                      <td
                        class="text-right"
                        style="word-break: break-word !important"
                      >{{getDateFormat(new Date())}}</td>
                    </tr>
                    <tr v-if="field.header_prop.doc_due_date.show">
                      <td
                        style="word-break: break-word !important"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_due_date.label}} :</td>
                      <td
                        class="text-right"
                        style="word-break: break-word !important"
                      >{{getDateFormat(new Date())}}</td>
                    </tr>
                    <tr v-if="field.header_prop.show_inv_no && field.menu_id == 3">
                      <td
                        style="word-break: break-word !important"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >Invoice No:</td>
                      <td class="text-right" style="word-break: break-word !important">INV100048</td>
                    </tr>
                    <tr
                      v-if="field.header_prop.hasOwnProperty('doc_shipment_date')&&field.header_prop.doc_shipment_date.show"
                    >
                      <td
                        style="word-break: break-word !important"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_shipment_date.label}} :</td>
                      <td
                        class="text-right"
                        style="word-break: break-word !important"
                      >{{getDateFormat(new Date())}}</td>
                    </tr>
                    <tr v-if="field.header_prop.doc_ref_no.show">
                      <td
                        style="word-break: break-word !important"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_ref_no.label}} :</td>
                      <td class="text-right" style="word-break: break-word !important">TN234556</td>
                    </tr>
                    <tr v-if="field.header_prop.doc_place_supply.show&&field.menu_id!=3">
                      <td
                        style="word-break: break-word !important"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_place_supply.label}} :</td>
                      <td class="text-right" style="word-break: break-word !important">Coimbatore</td>
                    </tr>
                    <tr
                      v-if=" field.header_prop.hasOwnProperty('doc_sales_person')&&field.header_prop.doc_sales_person.show "
                    >
                      <td
                        style="word-break: break-word !important"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_sales_person.label}} :</td>
                      <td
                        class="text-right"
                        style="word-break: break-word !important"
                      >{{field.menu_id==5 || field.menu_id == 10 ?'12':'Elavarasan'}}</td>
                    </tr>
                    <tr
                      v-if="field.header_prop.hasOwnProperty('doc_proj_name')&&field.header_prop.doc_proj_name.show"
                    >
                      <td
                        style="word-break: break-word !important"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_proj_name.label}} :</td>
                      <td
                        class="text-right"
                        style="word-break: break-word !important"
                      >Design project</td>
                    </tr>
                    <tr
                      v-if="field.header_prop.hasOwnProperty('payment_terms')&&field.header_prop.payment_terms.show"
                    >
                      <td
                        style="word-break: break-word !important"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.payment_terms.label}} :</td>
                      <td
                        class="text-right"
                        style="word-break: break-word !important"
                      >Due on Receipt</td>
                    </tr>
                    <tr
                      v-if="field.header_prop.hasOwnProperty('doc_eway_no')&&field.header_prop.doc_eway_no.show"
                    >
                      <td
                        style="word-break: break-word !important"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_eway_no.label}} :</td>
                      <td class="text-right" style="word-break: break-word !important">1233456</td>
                    </tr>
                    <template v-if="field.menu_id==10">
                      <tr v-if="field.header_prop.doc_ship_charge.show">
                        <td
                          style="word-break: break-word !important"
                          :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                          class="text-left semi-bold"
                        >{{field.header_prop.doc_ship_charge.label}} :</td>
                        <td class="text-right" style="word-break: break-word !important">2.00</td>
                      </tr>
                      <tr v-if="field.header_prop.doc_ship_track.show">
                        <td
                          style="word-break: break-word !important"
                          :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                          class="text-left semi-bold"
                        >{{field.header_prop.doc_ship_track.label}} :</td>
                        <td class="text-right" style="word-break: break-word !important">#234</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--End of Second Block -->
          <!-- Third Block -->
          <div
            class="invoice-third-block"
            style="display:flow-root;border-top:1px solid #ededed"
            v-if="field.menu_id != 5 && field.menu_id != 10"
          >
            <div style="display:flex;justify-content: space-between;margin-top:5px;">
              <!-- Shipping Details -->
              <div v-if="field.menu_id==1">
                <table class="custom-invoice-details-table">
                  <tbody>
                    <tr>
                      <td
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        class="text-left semi-bold"
                        style="padding-right:10px !important;word-break:break-word !important"
                      >Country of Supply :</td>
                      <td class="text-left" style="word-break:break-word !important">India</td>
                    </tr>
                    <tr>
                      <td
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        class="text-left semi-bold"
                        style="padding-right:10px !important;word-break:break-word !important"
                      >Export Type :</td>
                      <td class="text-left" style="word-break:break-word !important">Shipping</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="field.menu_id==1">
                <table class="shipping-details-table">
                  <tbody>
                    <tr>
                      <td
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        class="text-left semi-bold"
                        style="word-break:break-word !important"
                      >Shipping Bill No.</td>
                      <td
                        class="text-right"
                        style="word-break:break-word !important"
                      >{{getDateFormat(new Date())}}</td>
                    </tr>
                    <tr>
                      <td
                        style="word-break:break-word !important"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        class="text-left semi-bold"
                      >Shipping Bill Date</td>
                      <td
                        class="text-right"
                        style="word-break:break-word !important"
                      >{{getDateFormat(new Date())}}</td>
                    </tr>
                    <tr>
                      <td
                        style="word-break:break-word !important"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        class="text-left semi-bold"
                      >Shipping Port No.</td>
                      <td class="text-right" style="word-break:break-word !important">TN234556</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- End of Third Block -->
          <!-- Fourth Block-->
          <div
            v-if="field.header_prop.doc_inv_tag.show && field.menu_id != 5 "
            class="invoice-fourth-block"
            style="margin-top:5px;"
          >
            <table class="custom-invoice-details-table">
              <tbody>
                <tr>
                  <td
                    v-if="field.header_prop.hasOwnProperty('doc_inv_tag')"
                    class="text-left semi-bold label-invoice-tag"
                    style="padding-right:10px !important;word-break:break-word !important"
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >{{field.header_prop.doc_inv_tag.label}}</td>
                  <td
                    class="text-left"
                    style="word-break:break-word !important"
                  >: {{ field.menu_id== 10 ?'Truck':'Tags1, Tags2, Tags3'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End of Fourth Block -->
          <!-- Fifth Block -->
          <div class="invoice-fifth-block" style="margin-top:15px;">
            <table class="custom-invoice-line-item-table">
              <thead
                class="semi-bold"
                :style="{'background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
              >
                <th
                  v-if="field.item_prop.label.item_no.show"
                  :style="{'width':field.item_prop.label.item_no.width+'%'}"
                  class="text-right semi-bold"
                  style="word-break: break-word !important"
                >{{field.item_prop.label.item_no.label}}</th>
                <th
                  :style="{'width':(field.item_prop.label.item.show?field.item_prop.label.item.width:field.item_prop.label.desc.width)+'%'}"
                  v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                  class="text-left semi-bold"
                  style="word-break: break-word !important"
                >
                  <template
                    v-if="field.item_prop.label.item.show"
                  >{{field.item_prop.label.item.label+(field.item_prop.label.desc.show?field.item_prop.label.desc.label?(' & '+field.item_prop.label.desc.label):'& Description':'')}}</template>
                  <template v-else>{{field.item_prop.label.desc.label}}</template>
                </th>
                <th
                  :style="{'width':field.item_prop.label.hsn.width+'%'}"
                  v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                  class="semi-bold"
                  style="word-break: break-word !important"
                >{{field.item_prop.label.hsn.label}}</th>
                <th
                  :style="{'width':field.item_prop.label.qty.width+'%'}"
                  v-if="field.item_prop.label.qty.show"
                  class="text-right semi-bold"
                  style="word-break: break-word !important"
                >{{field.item_prop.label.qty.label}}</th>
                <th
                  :style="{'width':field.item_prop.label.rate.width+'%'}"
                  v-if="field.item_prop.label.rate.show"
                  class="text-right semi-bold"
                  style="word-break: break-word !important"
                >{{field.item_prop.label.rate.label}}</th>
                <th
                  v-if="field.item_prop.label.discount.show"
                  :style="{'width':field.item_prop.label.discount.width+'%'}"
                  class="text-right semi-bold"
                  style="word-break: break-word !important"
                >{{field.item_prop.label.discount.label}}</th>
                <th
                  :style="{'width':(field.item_prop.label.tax.show?field.item_prop.label.tax.width:(field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.width?field.item_prop.label.tax_amt.width:''))+'%'}"
                  v-if="field.item_prop.label.tax.show||(field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show)"
                  class="text-right semi-bold"
                  style="word-break: break-word !important"
                >
                  {{field.menu_id == 5 || field.menu_id == 10?'ISBN': 'CGST'}}
                  <!-- {{(field.item_prop.label.tax.show?field.item_prop.label.tax.label:field.item_prop.label.tax_amt.label)}} -->
                </th>
                <th
                  :style="{'width':field.item_prop.label.amt.width+'%'}"
                  v-if="field.item_prop.label.amt.show"
                  class="text-right semi-bold"
                  style="word-break: break-word !important;min-width:80px"
                >{{field.item_prop.label.amt.label}}</th>
              </thead>
              <tbody
                :style="{'font-size':(field.item_prop.layout.item_row_font_size||8)+'pt','color':field.item_prop.layout.hasOwnProperty('item_row_font_color')?field.item_prop.layout.item_row_font_color.hex:'#000','background':field.item_prop.layout.hasOwnProperty('item_row_bg_color')&&field.item_prop.layout.item_row_bg_color.show?field.item_prop.layout.item_row_bg_color.value.hex:'#fff'}"
              >
                <tr>
                  <td
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    v-if="field.item_prop.label.item_no.show"
                    class="text-right"
                    style="vertical-align:top"
                  >1</td>
                  <td
                    v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                    class="text-left"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    <span v-if="field.item_prop.label.item.show">Bournvita</span>
                    <span
                      v-if="field.item_prop.label.desc.show"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block"
                    >Bournvita,, is a brand of malted and chocolate malt drink mixes manufactured by Cadburys.</span>
                    <span
                      v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt'}"
                      style="display:block"
                    >HSN/SAC Code : 12345</span>
                  </td>
                  <td
                    v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >12345</td>
                  <td
                    v-if="field.item_prop.label.qty.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    {{field.menu_id == 5 ||field.menu_id == 10 ?'098765432112' : '1' }}
                    <span
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block;word-break: break-all"
                      v-if="field.item_prop.label.qty.show_unit && field.menu_id != 5 && field.menu_id != 10"
                    >Bag</span>
                  </td>
                  <td
                    v-if="field.item_prop.label.rate.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >{{field.menu_id == 5 ||field.menu_id == 10 ?'0987654321123' : '3,000.00' }}</td>
                  <td
                    v-if="field.item_prop.label.discount.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >{{field.menu_id == 5 ||field.menu_id == 10 ?'0987654321123' : '45.00' }}</td>
                  <td
                    v-if="field.item_prop.label.tax.show||(field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show)"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    <span
                      class="d-block"
                      v-if="field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show"
                    >18.00</span>
                    <span
                      v-if="field.item_prop.label.tax.show"
                      :style="{'border-bottom':field.item_prop.layout.item_font_color.hex,'font-size':field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show?'6pt':''}"
                    >{{field.menu_id == 5 ||field.menu_id == 10 ?'9783161484100' : '12%' }}</span>
                  </td>
                  <td
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    {{field.menu_id == 5 ||field.menu_id == 10?'1' : ' 2,955.00' }}
                    <span
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block;word-break: break-all"
                      v-if="field.item_prop.label.qty.show_unit &&(field.menu_id == 5 || field.menu_id == 10)"
                    >Bag</span>
                  </td>
                </tr>
                <tr>
                  <td
                    v-if="field.item_prop.label.item_no.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    style="vertical-align:top"
                  >2</td>
                  <td
                    v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                    class="text-left"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    <span v-if="field.item_prop.label.item.show">Bournvita</span>
                    <span
                      v-if="field.item_prop.label.desc.show"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block"
                    >Bournvita,, is a brand of malted and chocolate malt drink mixes manufactured by Cadburys.</span>
                    <span
                      v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt'}"
                      style="display:block"
                    >HSN/SAC Code : 12345</span>
                  </td>
                  <td
                    v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >12345</td>
                  <td
                    v-if="field.item_prop.label.qty.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    {{field.menu_id == 5 ||field.menu_id == 10?'098765432112' : '2' }}
                    <span
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block;word-break: break-all"
                      v-if="field.item_prop.label.qty.show_unit &&  field.menu_id != 5 && field.menu_id != 10"
                    >Bag</span>
                  </td>
                  <td
                    v-if="field.item_prop.label.rate.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >{{field.menu_id == 5 ||field.menu_id == 10?'0987654321123' : '900.00' }}</td>
                  <td
                    v-if="field.item_prop.label.discount.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >{{field.menu_id == 5 ||field.menu_id == 10 ?'0987654321123' : '90.00' }}</td>
                  <td
                    v-if="field.item_prop.label.tax.show||(field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show)"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    <span
                      class="d-block"
                      v-if="field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show"
                    >18.00</span>
                    <span
                      v-if="field.item_prop.label.tax.show"
                      :style="{'border-bottom':field.item_prop.layout.item_font_color.hex,'font-size':field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show?'6pt':''}"
                    >{{field.menu_id == 5 ||field.menu_id == 10 ?'9783161484100' : '12%' }}</span>
                  </td>
                  <td
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    {{field.menu_id == 5 ||field.menu_id == 10?'2' : ' 1,710.00' }}
                    <span
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block;word-break: break-all"
                      v-if="field.item_prop.label.qty.show_unit &&(field.menu_id == 5 || field.menu_id == 10)"
                    >Bag</span>
                  </td>
                </tr>
                <tr>
                  <td
                    v-if="field.item_prop.label.item_no.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    style="vertical-align:top"
                  >3</td>
                  <td
                    v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                    class="text-left"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    <span v-if="field.item_prop.label.item.show">Bournvita</span>
                    <span
                      v-if="field.item_prop.label.desc.show"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block"
                    >Bournvita,, is a brand of malted and chocolate malt drink mixes manufactured by Cadburys.</span>
                    <span
                      v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt'}"
                      style="display:block"
                    >HSN/SAC Code : 12345</span>
                  </td>
                  <td
                    v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                    style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >12345</td>
                  <td
                    v-if="field.item_prop.label.qty.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    {{field.menu_id == 5 ||field.menu_id == 10?'098765432112' : '3' }}
                    <span
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block;word-break: break-all"
                      v-if="field.item_prop.label.qty.show_unit &&  field.menu_id != 5 && field.menu_id != 10"
                    >NOS</span>
                  </td>
                  <td
                    v-if="field.item_prop.label.rate.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >{{field.menu_id == 5 ||field.menu_id == 10?'0987654321123' : '800.00' }}</td>
                  <td
                    v-if="field.item_prop.label.discount.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >{{field.menu_id == 5 ||field.menu_id == 10?'0987654321123' : '48.00' }}</td>
                  <td
                    v-if="field.item_prop.label.tax.show||(field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show)"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    <span
                      class="d-block"
                      v-if="field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show"
                    >18.00</span>
                    <span
                      v-if="field.item_prop.label.tax.show"
                      style="display:block"
                      :style="{'border-bottom':field.item_prop.layout.item_font_color.hex,'font-size':field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show?'6pt':''}"
                    >{{field.menu_id == 5 ||field.menu_id == 10 ?'9783161484100' : '12%' }}</span>
                  </td>
                  <td
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                  >
                    {{field.menu_id == 5 ||field.menu_id == 10?'3' : '2,352.00' }}
                    <span
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                      style="display:block;word-break: break-all"
                      v-if="field.item_prop.label.qty.show_unit && ( field.menu_id == 5 ||field.menu_id == 10)"
                    >NOS</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End of Fifth Block -->
          <!-- Sixth Block -->
          <!-- Subtotal,total -->
          <!-- Tax,Discount -->
          <!-- Balance Due -->
          <div
            v-if="field.total_prop.label.show_total_sec  && field.menu_id != 5 && field.menu_id != 10"
            class="invoice-sixth-block"
            style="display: flow-root;"
          >
            <table
              v-if="field.total_prop.label.sub_total.show&& field.total_prop.label.show_total_qty"
              class="custom-invoice-total-table float-left"
              style="width:40%;word-break:break-word;border-collapse: collapse !important;"
            >
              <tbody>
                <tr>
                  <td>
                    <span
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      v-if="field.total_prop.label.show_total_qty"
                    >{{field.total_prop.label.item_in_total}} :</span>
                    <span
                      :style="{'color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000','font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    >6.00</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              class="custom-invoice-total-table float-right"
              style="width:60%;word-break:break-word"
            >
              <tbody>
                <tr v-if="field.total_prop.label.sub_total.show">
                  <td
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    class="semi-bold"
                  >
                    <span class="float-right">{{field.total_prop.label.sub_total.label}}</span>
                  </td>
                  <td
                    style="width:150px;padding-right: 8px !important"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >
                    <span
                      :class="{'float-right':field.total_prop.label.currency_syb==2}"
                    >{{orgCurrencySymbol}}</span> 7,017.00
                  </td>
                </tr>
                <tr v-if="field.total_prop.label.show_discount">
                  <td
                    class="text-right"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >Discount</td>
                  <td
                    class="text-right"
                    style="width:150px;padding-right: 8px !important"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >
                    <span
                      :class="{'float-right':field.total_prop.label.currency_syb==2}"
                    >{{orgCurrencySymbol}}</span> (-)183.00
                  </td>
                </tr>
                <tr
                  v-if="field.total_prop.label.hasOwnProperty('total_tax_amt')&&field.total_prop.label.total_tax_amt.show"
                >
                  <td
                    class="text-right"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >{{field.total_prop.label.total_tax_amt.label}}</td>
                  <td
                    class="text-right"
                    style="width:150px;padding-right: 8px !important"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >
                    <span
                      :class="{'float-right':field.total_prop.label.currency_syb==2}"
                    >{{orgCurrencySymbol}}</span> 6,834.00
                  </td>
                </tr>
                <tr>
                  <td
                    class="text-right"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >IGST[12%]</td>
                  <td
                    style="width:150px;padding-right: 8px !important"
                    class="text-right"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >
                    <span
                      :class="{'float-right':field.total_prop.label.currency_syb==2}"
                    >{{orgCurrencySymbol}}</span> 842.04
                  </td>
                </tr>
                <tr
                  v-if="field.total_prop.label.amt_withheld&&field.total_prop.label.show_pay_detail"
                >
                  <td
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >
                    {{field.total_prop.label.amt_withheld}}
                    <p v-if="id==17" class="m-0" style="font-size:6pt;">(Section 194 H)</p>
                  </td>
                  <td
                    style="width:150px;padding-right: 8px !important"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >
                    <span
                      :class="{'float-right':field.total_prop.label.currency_syb==2}"
                    >{{orgCurrencySymbol}}</span>
                    {{id==17?'(-)':''}}0.00
                  </td>
                </tr>
                <tr>
                  <template v-if="field.total_prop.label.show_pay_detail">
                    <td
                      class="text-right semi-bold"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    >{{field.total_prop.label.total}}</td>
                    <td
                      style="width:150px;padding-right: 8px !important"
                      class="text-right semi-bold"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> 7,859.04
                    </td>
                  </template>
                  <template v-else>
                    <td
                      style="word-break:break-word"
                      class="text-right semi-bold"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                    >{{field.total_prop.label.total}}</td>
                    <td
                      style="width:150px;word-break:break-word"
                      class="text-right semi-bold"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> 7,859.04
                    </td>
                  </template>
                </tr>
                <template v-if="field.menu_id == 9">
                  <tr>
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    >Credits Used</td>
                    <td
                      style="font-style:italic;width:150px;padding-right: 8px !important"
                      class="text-right text-danger"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> (-) 859.00
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-right semi-bold"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                    >Credits Remaining</td>
                    <td
                      style="width:150px;padding-right: 8px !important"
                      class="text-right semi-bold"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> 6,859.04
                    </td>
                  </tr>
                </template>

                <template
                  v-if="(field.menu_id==1||field.menu_id==3 || field.menu_id == 8)&&field.total_prop.label.show_pay_detail"
                >
                  <tr style="background:#fff !important;">
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;"
                    >{{field.total_prop.label.pay_made}}</td>

                    <td
                      class="text-right text-danger"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;width:150px;padding-right: 8px !important"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> (-) 0.00
                    </td>
                  </tr>
                  <tr style="background:#fff !important;">
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;"
                    >{{field.total_prop.label.credits_apply}}</td>
                    <td
                      class="text-right text-danger"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;width:150px;padding-right: 8px !important"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> (-) 0.00
                    </td>
                  </tr>
                  <tr style="background:#fff !important;" v-if="!menu_id == 8">
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;"
                    >{{field.total_prop.label.writeoff_amt_label}}</td>
                    <td
                      class="text-right text-danger"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;width:150px;padding-right: 8px !important"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> (-) 0.00
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="font-style:italic;"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                      class="text-right"
                    >{{field.total_prop.label.bal_due}}</td>
                    <td
                      style="font-style:italic;width:150px;padding-right: 8px !important"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                      class="text-right"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> 7,859.04
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <!-- End of sixth block -->

          <!-- Seventh Block -->
          <template v-if="field.menu_id != 5">
            <div class="invoice-seventh-block" v-if="field.menu_id !=10">
              <div
                v-if="field.total_prop.label.show_amt_wrd"
                class="text-left semi-bold"
                style="word-break:break-word"
              >Total Amount (in words) : Rupees Seven Thousand Eight Hundred And Fifty Nine And Four Paise Only</div>
              <div style="border-top:1px solid #ededed;margin-bottom:2px;"></div>
              <div class="text-right" :style="{'font-size':6+'pt'}">
                <i>E. & O.E</i>
              </div>
            </div>
            <!-- End of seventh block -->

            <!-- Eigth Block  -->
            <div class="invoice-eigth-block" style="display: flow-root;" v-if="field.menu_id !=10">
              <div class="signature-block">
                <div class="float-left" v-if="field.footer_prop.signature.show">
                  <div
                    class="semi-bold text-right mb-2"
                    style="word-break:break-word"
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >{{field.footer_prop.signature.label}}</div>
                  <hr style="border-color:#000;margin-bottom:0px;margin-top: 1.5rem" />
                  <div
                    class="text-left"
                    style="word-break:break-word"
                  >{{field.footer_prop.signature.name}}</div>
                </div>
                <div
                  class="float-right"
                  v-if="field.footer_prop.hasOwnProperty('add_signature')&&field.footer_prop.add_signature.show"
                >
                  <div
                    class="semi-bold text-right mb-2"
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                    style="word-break:break-word"
                  >{{field.footer_prop.add_signature.label}}</div>
                  <hr style="border-color:#000;margin-bottom:0px;margin-top: 1.5rem" />
                  <div
                    class="text-left"
                    style="word-break:break-word"
                  >{{field.footer_prop.add_signature.name}}</div>
                </div>
              </div>
            </div>
            <!--End of  Eigth Block  -->

            <!-- Ninth Block -->
            <div class="invoice-ninth-block" v-if="field.footer_prop.show_term_con">
              <div
                class="terms-conditions"
                :style="{'font-size':field.footer_prop.term_font_size+'pt'}"
              >
                <div
                  class="semi-bold text-left"
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  style="word-break:break-word"
                >{{field.footer_prop.term_label}}</div>
                <div
                  style="word-break: break-word;white-space:pre"
                >Looking forward for your business</div>
              </div>
            </div>
            <!--End of Ninth Block -->
            <!-- Tenth Block -->
            <div class="invoice-tenth-block">
              <div class="invoice-notes">
                <div
                  class="text-center"
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  style="word-break:break-word"
                >{{field.footer_prop.note_label||''}}</div>
                <div
                  :style="{'font-size':field.footer_prop.note_font_size+'pt'}"
                  class="text-center"
                  style="word-break:break-word"
                >Looking forward for your business</div>
              </div>
            </div>
            <!-- End of Tenth Block -->
          </template>

          <div class="bill-details-block" v-if="field.menu_id == 9" style="margin-top:20px;">
            <h6>{{field.item_prop.label.applied_to}}</h6>
            <table class="custom-invoice-line-item-table" style="width:100%">
              <thead
                class="semi-bold"
                :style="{'background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
              >
                <th
                  style="word-break:break-word"
                  v-if="field.item_prop.label.bill_date.show"
                  class="semi-bold"
                >{{field.item_prop.label.bill_date.label}}</th>
                <th
                  style="word-break:break-word"
                  v-if="field.item_prop.label.bill_no.show"
                  class="semi-bold"
                >{{field.item_prop.label.bill_no.label}}</th>

                <th
                  style="word-break:break-word"
                  v-if="field.item_prop.label.bill_amount.show"
                  class="text-right semi-bold"
                >{{field.item_prop.label.bill_amount.label}}</th>
                <th
                  style="word-break:break-word"
                  v-if="field.item_prop.label.payment_amount.show"
                  class="text-right semi-bold"
                >{{field.item_prop.label.payment_amount.label}}</th>
              </thead>
              <tbody
                :style="{'font-size':(field.item_prop.layout.item_row_font_size||8)+'pt','color':field.item_prop.layout.hasOwnProperty('item_row_font_color')?field.item_prop.layout.item_row_font_color.hex:'#000','background':field.item_prop.layout.hasOwnProperty('item_row_bg_color')&&field.item_prop.layout.item_row_bg_color.show?field.item_prop.layout.item_row_bg_color.value.hex:'#fff'}"
              >
                <tr>
                  <td
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    v-if="field.item_prop.label.bill_date.show"
                    style="vertical-align:top;word-break:break-word"
                  >24/12/2020</td>
                  <td
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    v-if="field.item_prop.label.bill_no.show"
                    style="vertical-align:top;word-break:break-word"
                  >BILL101</td>
                  <td
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    v-if="field.item_prop.label.bill_amount.show"
                    class="text-right"
                    style="vertical-align:top;word-break:break-word"
                  >468.00</td>
                  <td
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}"
                    v-if="field.item_prop.label.payment_amount.show"
                    class="text-right"
                    style="vertical-align:top;word-break:break-word"
                  >32.00</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- Body End -->
        <div
          class="invoice-footer-block"
          :style="{'height':field.temp_prop.margin_bottom+'in','background':field.footer_prop.bg_color.show==1?field.footer_prop.bg_color.value.hex:'#fff','color':field.footer_prop.hasOwnProperty('footer_color')?field.footer_prop.footer_color.hex:'#000','font-size':(field.footer_prop.footer_font_size||7)+'pt'}"
        ></div>
      </div>
    </div>
    <!-- End of A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import { mapGetters } from "vuex";
export default {
  props: ["list", "id"],
  data() {
    return {
      field: JSON.parse(JSON.stringify(this.list)),
      imageSrc: ""
    };
  },
  methods: {
    preview(eve) {
      this.field = JSON.parse(JSON.stringify(eve));
    }
  },
  created() {
    this.imageSrc =
      this.org_details.org_logo != null && this.org_details.org_logo != ""
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : "";
  },
  mounted() {
    EventBus.$on("preview", this.preview); // to trigger the method from parentcomponent
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapGetters(["org_details", "inv_settings_details", "orgCurrencySymbol"])
  }
};
</script>



<style lang="scss" scoped>
// A4 STANDARD PORTRAIT CSS
// Bootstrap class
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
//Custom css
//A4 standard portrait
#a4-standard-portrait-page {
  width: 21cm;
  min-height: 29.7cm;
}
//A4 standard landscape //A4 spreadsheet landscape
#a4-standard-landscape-page {
  width: 29.7cm;
  min-height: 21cm;
}
//A5 standard portrait
#a5-standard-portrait-page {
  width: 14.8cm;
  min-height: 21cm;
}
//A5 spreadsheet portrait
#a5-standard-landscape-page {
  width: 21cm;
  min-height: 14.8cm;
}

#a4-standard-portrait-page .print-template {
  zoom: 115%;
}
#a4-standard-landscape-page .invoice-content-layout {
  zoom: 130%;
}

#a5-standard-landscape-page .print-template,
#a4-standard-landscape-page .print-template {
  zoom: 80%;
}

.invoice-top-heading {
  margin-bottom: 30px;
}
.custom-invoice-address p {
  margin-bottom: 1px !important;
  font-size: 8pt;
}
.custom-invoice-address {
  margin-bottom: 5px;
}
table.custom-invoice-details-table > tbody > tr > td {
  padding: 1px !important;
}
table.custom-invoice-total-table.float-right > tbody > tr > td {
  padding: 2px !important;
}
table.shipping-details-table,
table.custom-invoice-line-item-table {
  border-collapse: collapse;
}
table.shipping-details-table td {
  border: 1px solid #ededed;
  padding: 3px !important;
}
table.custom-invoice-line-item-table thead > th {
  padding: 6px;
}
table.custom-invoice-line-item-table tbody > tr > td {
  padding: 8px !important;
}
.signature-block {
  margin-top: 60px;
}
.terms-conditions {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.label-invoice-tag {
  width: 100px;
}
@media (min-width: 10px) and (max-width: 768px) {
  #a4-standard-portrait-page.responsive-print {
    zoom: 36%;
  }
  #a4-standard-landscape-page.responsive-print {
    zoom: 26%;
  }
  #a5-standard-portrait-page.responsive-print {
    zoom: 52%;
  }
  #a5-standard-landscape-page.responsive-print {
    zoom: 36%;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  #a4-standard-portrait-page.responsive-print {
    zoom: 50%;
  }

  #a4-standard-landscape-page.responsive-print {
    zoom: 35%;
  }
  #a5-standard-portrait-page.responsive-print {
    zoom: 70%;
  }
  #a5-standard-landscape-page.responsive-print {
    zoom: 50%;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  #a4-standard-portrait-page.responsive-print {
    zoom: 70%;
  }
  #a4-standard-landscape-page.responsive-print {
    zoom: 55%;
  }
  #a5-standard-portrait-page.responsive-print {
    zoom: 100%;
  }
  #a5-standard-landscape-page.responsive-print {
    zoom: 80%;
  }
}
@media (min-width: 1281px) and (max-width: 1366px) {
  #a4-standard-portrait-page.responsive-print {
    zoom: 80%;
  }
  #a4-standard-landscape-page.responsive-print {
    zoom: 62%;
  }
  #a5-standard-portrait-page.responsive-print {
    zoom: 100%;
  }
  #a5-standard-landscape-page.responsive-print {
    zoom: 75%;
  }
}
@media (min-width: 1367px) and (max-width: 1440px) {
  #a4-standard-portrait-page.responsive-print {
    zoom: 75%;
  }
  #a4-standard-landscape-page.responsive-print {
    zoom: 70%;
  }
  #a5-standard-portrait-page.responsive-print {
    zoom: 85%;
  }
  #a5-standard-landscape-page.responsive-print {
    zoom: 85%;
  }
}
</style>
